import React from 'react';
// import {Link} from 'react-router-dom';
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import bg from '../../images/banner/slid1.PNG';
import bg1 from '../../images/banner/b3.jpg';
import bg2 from '../../images/banner/b5.jpg';

import './css/Banner.css';

const AutoplaySlider = withAutoplay(AwesomeSlider);

const Banner = () => {
  return (
    <section>
      <AutoplaySlider
        play={true}
        cancelOnInteraction={false} // should stop playing on user interaction
        interval={6000}
        bullets={false}
        className='aws-btn'
      >
        <div data-src={bg} className='bannerImg' alt='Harshitha township'>
        </div>

        <div data-src={bg1} className='bannerImg' alt='Harshitha developers a prayer city'>
        </div>
        
        <div data-src={bg2} className='bannerImg' alt='Harshitha developers mega gated community'>
        </div>
      </AutoplaySlider>
    </section>
  );
};

export default Banner;
// <div>
//             <h2 data-aos="fade-up" data-aos-duration="1000">
//               we provide high quality{' '}
//               <span style={{ color: '#3498db' }}>work</span>{' '}
//             </h2>
//             <p data-aos="fade-up" data-aos-duration="1200">We're Technology Focused.</p>
//             <Link to='/work' className='btn' data-aos="fade-up" data-aos-duration="1400">view work</Link>
          //           </div>

// <div>
// <h2 data-aos="fade-up" data-aos-duration="1000">
//   we provide high quality{' '}
//   <span style={{ color: '#3498db' }}>team</span>{' '}
// </h2>

// <p data-aos="fade-up" data-aos-duration="1200">We're Not Just Advertisers. We're Creators.</p>
// <Link to='/about' className='btn' data-aos="fade-up" data-aos-duration="1400">view team</Link>
// </div>